import { tour } from 'aria-viewer/utils/functions'
import { getTourData } from 'aria-viewer/analytics/utils/analyticUtils'

export const getPaymentProperties = () => getState => {
    const { inst_name, owner_id, loc_name, loc_id, stoptitle, stopid, itemTitle, itemID } = getTourData()(getState)

    return {
        Institution: inst_name,
        Inst_ID: owner_id,
        Location: loc_name,
        Loc_ID: loc_id,
        Stop: stoptitle,
        Stop_ID: stopid,
        Item: itemTitle,
        Item_ID: itemID,
    }
}

export const getPaymentPropertiesWithShippingAddress = () => getState => {
    const paymentProperties = getPaymentProperties()(getState)
    const { paymentShippingAddress } = getTourData()(getState)

    const fullName = paymentShippingAddress.getIn(['values', 'fullName'])
    const address = paymentShippingAddress.getIn(['values', 'address'])
    const zipcode = paymentShippingAddress.getIn(['values', 'zipcode'])
    const town = paymentShippingAddress.getIn(['values', 'town'])
    const country = paymentShippingAddress.getIn(['values', 'country'])
    const state = paymentShippingAddress.getIn(['values', 'state'])
    const email = paymentShippingAddress.getIn(['values', 'email'])

    return {
        ...paymentProperties,
        Name: fullName,
        Email: email,
        ['Shipping Address1']: address,
        ['Shipping City']: town,
        ['Shipping State']: state,
        ['Shipping Country']: country,
        ['Shipping Zip']: zipcode,
    }
}
